<template>
  <div>
    <el-tabs v-model="curView" type="card" @tab-click="handleTabsClick" closable @edit="handleTabsEdit" style="height: 45px; padding: 0">
      <el-tab-pane
        :key="item.name"
        v-for="(item, index) in viewsList"
        :label="item.title"
        :name="item.name"
      >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  created() {
    window.addEventListener("onEventAfterEach", event => {undefined
      let data =event.detail;

      if (data.showHis == false){
        return;
      }

      for (let i = 0;i< this.viewsList.length;++i){
        let view =this.viewsList[i];
        if (view.path == data.path && view.title == data.title){
          this.curView = data.path;
          return;
        }
      }
      if (this.viewsList.length>10){
        this.viewsList.shift();
      }
      data.name = data.path
      this.curView = data.name;
      this.viewsList.push(data);
    })

  },
  name: 'HistoryVueList',
  data() {
    return {
      curView:"",
      viewsList: [

      ]
    }
  },

  methods: {
    handleTabsEdit(targetName, action){
      if (action === 'remove') {
        for (let i = 0;i< this.viewsList.length;++i){
          if ( this.viewsList[i].name == targetName){
            this.viewsList.splice(i,1)
          }
        }
      }
    },
    handleTabsClick(tag){
      this.$router.push(tag.name);
    }
  }
}
</script>

<style  scoped>
  /deep/ .el-tabs__header {
    width: 60%;
  }
  /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none;
  }
  /deep/ .el-tabs__item{
    height: 40px;
    color: #0e6eba;
    background: #cedef5;
    margin-right: 10px;
    border-radius: 8px;
  }
  /deep/ .el-tabs__item.is-active{
    color: #ffffff;
    background: linear-gradient(120.93deg, #1270b8 3.98%, #5aaeee 100%);
  }

  /deep/ .el-tabs__active-bar{
    display: none;
  }
  /deep/ .el-tabs__nav-wrap::after{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/HistoryVueList/index.vue